import { useEffect, useRef, useState } from "react";

import { Box, Button, IconButton, Typography } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { ChevronLeft, ChevronRight, Close } from "@material-ui/icons";
import { observer } from "mobx-react-lite";

import AnnouncementContent from "./AnnouncementContent";
import useAnnouncements from "../../hooks/useAnnouncements";

const AnnouncementModal = observer(() => {
  const { items, current, setIndex, prev, dismiss } =
    useAnnouncements("modal");
  const [open, setOpen] = useState(false);
  const wasEmptyRef = useRef(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const displayAnnouncement = current
    ? {
        ...current,
        imagePosition:
          isSmallScreen &&
          (current.imagePosition === "left" || current.imagePosition === "right")
            ? "top"
            : current.imagePosition,
      }
    : current;

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (!items.length) {
      wasEmptyRef.current = true;
      setOpen(false);
      return;
    }
    if (wasEmptyRef.current) {
      wasEmptyRef.current = false;
      setIndex(0);
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  if (!open || !current) {
    return null;
  }

  const handleDismiss = () => {
    if (current?._id && typeof window !== "undefined") {
      dismiss(current._id);
    }
  };

  const handleNext = () => {
    handleDismiss();
  };

  return (
    <Box
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          handleDismiss();
        }
      }}
    >
      <Box
        style={{
          borderRadius: 16,
          backgroundColor: "#ffffff",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          overflow: "hidden",
          position: "relative",
          maxWidth:
            displayAnnouncement?.imagePosition === "left" ||
            displayAnnouncement?.imagePosition === "right"
              ? 720
              : 500,
          width: "100%",
          maxHeight: "85vh",
          overflowY: "auto",
          padding: "32px 24px 24px",
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <AnnouncementContent
          announcement={displayAnnouncement}
          onActionClick={handleDismiss}
          navigation={
            items.length > 1 ? (
              <Box display="flex" alignItems="center">
                <IconButton
                  onClick={prev}
                  aria-label="previous announcement"
                  size="small"
                >
                  <ChevronLeft />
                </IconButton>
                <Typography variant="caption" style={{ margin: "0 4px" }}>
                  {items.findIndex((item) => item._id === current._id) + 1} /{" "}
                  {items.length}
                </Typography>
                <IconButton
                  onClick={handleNext}
                  aria-label="next announcement"
                  size="small"
                >
                  <ChevronRight />
                </IconButton>
              </Box>
            ) : null
          }
          action={
            <Button
              size="small"
              variant="outlined"
              onClick={handleDismiss}
              aria-label="close announcement"
              startIcon={<Close />}
            >
              Close
            </Button>
          }
        />
      </Box>
    </Box>
  );
});

export default AnnouncementModal;
